<template>
  <div></div>
</template>

<script>
import axios from "axios";
export default {
  name: "refresh",
  data() {
    return {};
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      var token = vm.$route.query.token;
      var userName = vm.$route.query.userName;

      let url = "/api/login/taohd?token=" + token;
      window.open(url, "_self");
    });
  },
};
</script>
<style scoped></style>
